import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setViewportHeight } from './utils/viewport';

// Initial set
setViewportHeight();

// Update on resize and orientation change
window.addEventListener('resize', setViewportHeight);
window.addEventListener('orientationchange', setViewportHeight);

// Add scroll event handler to catch when browser UI appears/disappears
window.addEventListener('scroll', () => {
  // Only apply to homepage
  if (window.isHomePage) {
    // Debounce recalculation to avoid performance issues
    if (!window.isRecalculating) {
      window.isRecalculating = true;
      setTimeout(() => {
        setViewportHeight();
        window.isRecalculating = false;
      }, 100);
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
